import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";

import { MediaBlock } from "./MediaBlocks";
import { Schedule } from "./Schedule";
dayjs.extend(isBetween);

const MOCK_CAMPAIGNS = [
  {
    id: 1,
    name: "CAMPAIGN-1",
    start_time: "00:00:00",
    end_time: "23:00:00",
    blocks: [
      {
        name: "CAMPAIGN-1-BLOCK-1",
        media: [
          {
            display_name: "CAMPAIGN-1-BLOCK-1-1",
            path: "A-1",
            duration: 3,
          },
          {
            display_name: "CAMPAIGN-1-BLOCK-1-2",
            path: "A-2",
            duration: 4,
          },
        ],
      },
      {
        name: "CAMPAIGN-1-BLOCK-2",
        media: [
          {
            display_name: "CAMPAIGN-1-BLOCK-2-1",
            path: "A-1",
            duration: 2,
          },
          {
            display_name: "CAMPAIGN-1-BLOCK-2-2",
            path: "A-2",
            duration: 2,
          },
        ],
      },
    ],
    // max_duration: 35,
  },
  {
    id: 2,
    name: "CAMPAIGN-2",
    start_time: "11:18:00",
    end_time: "14:00:00",
    blocks: [
      {
        name: "CAMPAIGN-2-BLOCK-1",
        media: [
          {
            display_name: "CAMPAIGN-2-BLOCK-1-1",
            path: "A-1",
            duration: 15,
          },
        ],
      },
      {
        name: "CAMPAIGN-2-BLOCK-2",
        media: [
          {
            display_name: "CAMPAIGN-2-BLOCK-2-1",
            path: "A-1",
            duration: 8,
          },
          {
            display_name: "CAMPAIGN-2-BLOCK-2-2",
            path: "A-2",
            duration: 9,
          },
        ],
      },
    ],
    // max_duration: 17,
  },
  {
    id: 3,
    name: "CAMPAIGN-3",
    start_time: "16:00:00",
    end_time: "17:00:00",
    blocks: [
      {
        name: "CAMPAIGN-BLOCK-3",
        media: [
          {
            display_name: "CAMPAIGN-BLOCK-3-1",
            path: "A-1",
            duration: 15,
          },
        ],
      },
    ],
    // max_duration: 15,
  },
];

export default function MediaPlayer() {
  const [campaignElapsedTime, setCampaignElapsedTime] = useState(0);
  const [currentCampaignIndex, setCurrentCampaignIndex] = useState(0);
  const intervalRef = useRef(null);
  const [playCampaignCount, setPlayCampaignCount] = useState(1);
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const filterIntervalRef = useRef(null);

  const [campaigns, setCampaigns] = useState([]);

  const currentCampaign = _.get(filteredCampaigns, [currentCampaignIndex]);
  const currentCampaignMaxDuration = _.get(currentCampaign, ["max_duration"]);

  const initData = () => {
    const campaignsWithMaxDuration = _.chain(MOCK_CAMPAIGNS)
      // filter no adsBlocks
      .map((campaign) => {
        const maxDuration = _.chain(campaign.blocks)
          .flatMap("media")
          .sumBy("duration")
          .value();
        return { ...campaign, max_duration: maxDuration };
      })
      .value();
    setCampaigns(campaignsWithMaxDuration);
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    filterCampaigns();
    filterIntervalRef.current = setInterval(filterCampaigns, 60000);

    return () => {
      clearInterval(filterIntervalRef.current);
    };
  }, [campaigns]);

  useEffect(() => {
    if (_.size(filteredCampaigns) > 0) {
      const timer = setTimeout(() => {
        handleNextCampaign();
      }, _.get(filteredCampaigns[currentCampaignIndex], ["max_duration"]) * 1000);

      intervalRef.current = setInterval(() => {
        setCampaignElapsedTime((prev) => prev + 1);
      }, 1000);

      return () => {
        clearTimeout(timer);
        clearInterval(intervalRef.current);
      };
    }
  }, [currentCampaignIndex, filteredCampaigns]);

  const filterCampaigns = () => {
    const now = dayjs();
    const filtered = _.filter(campaigns, (campaign) => {
      const startTime = dayjs()
        .set("hour", campaign?.start_time.split(":")[0])
        .set("minute", campaign?.start_time.split(":")[1])
        .set("second", campaign?.start_time.split(":")[2]);
      const endTime = dayjs()
        .set("hour", campaign?.end_time.split(":")[0])
        .set("minute", campaign?.end_time.split(":")[1])
        .set("second", campaign?.end_time.split(":")[2]);
      return (
        (now.isSame(startTime) || now.isAfter(startTime)) &&
        (now.isBefore(endTime) || now.isSame(endTime))
      );
    });

    setFilteredCampaigns(filtered);
  };

  const handleNextCampaign = () => {
    setCampaignElapsedTime(0);
    setCurrentCampaignIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % _.size(filteredCampaigns);
      if (nextIndex === 0) {
        setPlayCampaignCount((prev) => prev + 1);
        filterCampaigns();
      }
      return nextIndex;
    });
  };

  return (
    <div style={{ background: "white" }}>
      <div>round: {playCampaignCount}</div>
      <div>CampaignElapsedTime: {campaignElapsedTime}</div>
      <div>Campaign: {_.get(currentCampaign, ["name"])}</div>
      <div>Max Duration: {currentCampaignMaxDuration} seconds</div>
      <div>============================================</div>
      {_.size(filteredCampaigns) === 0 ? (
        <div>No Media</div>
      ) : (
        _.chain(currentCampaign)
          .get(["blocks"], [])
          .map((item, index) => {
            return (
              <MediaBlock
                key={index}
                block={item}
                playCampaignCount={playCampaignCount}
              />
            );
          })
          .value()
      )}
      <Schedule campaigns={campaigns} />
    </div>
  );
}
